import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

export class Details extends Component {
  render() {
    return (
      <Div>
        <Line>
          <TextDiv>
            <P>Payment Gateway:</P>
            <P2>{this.props.gateway}</P2>
          </TextDiv>
        </Line>
        <Line>
          <TextDiv>
            <P>Fee:</P>
            <P2>{this.props.fee} {this.props.currencyCode}</P2>
          </TextDiv>
        </Line>
        <Line>
          <TextDiv>
            <P>Total:</P>
            <P2>{this.props.total} {this.props.currencyCode}</P2>
          </TextDiv>
        </Line>
        <br />
      </Div >
    )
  }
}

const Line = styled.div`
  border-bottom-style: dashed;
  border-color: #CCCCCC;
  border-width: 1.5px;
  flex: 1;
`

const Div = styled.div`
  display: flex;
  flex-direction: column;
`

const P = styled.p`
  color: #B3B3B3;
  line-height: 5px;
  float: left;
`

const P2 = styled.p`
  color: #4D4D4D;
  line-height: 5px;
  float: right;
`

const TextDiv = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`

const mapStateToProps = (state) => ({
  gateway: 'Simplex',
  fee: parseFloat(state.buy.rates.total_amount - state.buy.rates.base_amount).toFixed(2),
  total: state.buy.rates.total_amount,
  currencyCode: state.buy.params.currencyCode
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Details)
